import { css } from '@emotion/react';

const globalStyles = css`
  body {
    padding: 0;
    margin: 0;
    font-family: 'General Sans';
    overflow-x: hidden;
    width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  p {
    margin: 0;
  }

  a {
    cursor: pointer;
    text-decoration: none;
    color: #2addba;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    transition: all 5000s ease-in-out 0s;
  }
`;

export default globalStyles;
